<template>
  <div class="iv-table-qusetion" :id="item.questionId">
    <p class="iv-fs-16 iv-fc-85 iv-p-t-16 iv-p-b-16 iv-fw-6">{{index + 1}}.&nbsp;[表格题] {{item.questionName}}</p>
    <div class="iv-table-operation" v-if="this.state == 1">
      <div class="iv-pull-left iv-m-r-20 iv-main-color iv-pointer uit-question-row-add" @click="addRow">
        <IconFont type="Plus" class="iv-fs-16 iv-m-r-8"></IconFont>
        <span class="uit-add">新增行</span>
      </div>
      <div class="iv-pull-left iv-m-r-20 iv-main-color iv-pointer uit-question-row-del" @click="delRow">
        <IconFont type="delete" class="iv-fs-16 iv-m-r-8"></IconFont>
        <span class="uit-add">删除行</span>
      </div>
    </div>
    <Table ref="myTable" border :columns="columns" :data="vueQusetion" class="table-qusetion" :stripe="true">
      <template slot="name" slot-scope="props">
        <div class="content" @click="state == 1 ? props.row[props.id].show=true : ''" v-show="!props.row[props.id].show">
          {{props.row[props.id].name}}
        </div>
        <input v-model="props.row[props.id].name" @blur="inputBlur(props, props.idx)" v-show="!!props.row[props.id].show" />
      </template>
    </Table>
  </div>
</template>
<script>
import IconFont from '@/components/iconfont'
export default {
  props: ['index', 'item'],
  data () {
    return {
      data: [],
      vueQusetion: [],
      columns: [],
      timer: '',
      rowsCount: 0,
      state: 0
    }
  },
  created () {
    this.state = this.$route.query.state
  },
  beforeUpdate () {
    // console.log('我变化了--table')
  },
  mounted () {
    this.$nextTick(() => {
      this.creatTable()
    })
  },
  methods: {
    //行
    addRow () {
      let obj = {}
      let questionObj = []
      this.columns.forEach((item, index) => {
        obj[index] = {name: '', show: false}
        questionObj[index] = ''
      })
      obj[0] = this.vueQusetion.length + 1
      questionObj[0] = this.vueQusetion.length + 1
      this.vueQusetion.push(obj)
      this.item.questionMap[this.vueQusetion.length] = questionObj
    },
    delRow () {
      if (this.vueQusetion.length > this.rowsCount) {
        this.vueQusetion.pop()
      }
    },
    inputBlur (props) {
      props.row[props.id].show = false
      this.item.vueQusetion[props.idx][props.id].name = props.row[props.id].name
      this.item.questionMap[props.idx + 1][props.id] = props.row[props.id].name
      //let activeAnswer = !!props.row[props.id].name
      this.isAnswer(this.item.vueQusetion[props.idx][props.id])
    },
    creatTable () {
      //this.item.vueQusetion
      //创建行
      //this.item.vueQusetion = []
      for (let item in this.item.questionMap) {
        let obj = {}
        for (let i in this.item.questionMap[item]) {
          //生成表格行
          if (item == 0) {
            this.columns.push({
              title: this.item.questionMap[item][i],
              key: i
            })
          } else {
            if (i <= this.item.rowsNum) {
              obj[i] = this.item.questionMap[item][i]
            } else {
              let temp = {}
              temp.name = this.item.questionMap[item][i]
              temp.show = false
              obj[i] = temp
              if (item == 1) {
                this.columns[i].render = (h, params) => {
                  //this.item.vueQusetion[params.index] = params.row
                  //this.change(params)
                  let id = this.columns[i].key
                  return h(
                    'div',
                    this.$refs.myTable.$scopedSlots.name({
                      id: id,
                      row: params.row,
                      idx: params.row._index
                    })
                  )
                }
              }
            }
          }
        }
        (item != 0 && this.vueQusetion.push(obj))
        this.item.vueQusetion = this.vueQusetion
      }
      this.rowsCount = this.item.questionRows.split('[questiontable]').length
      // console.log(this.columns)
      // console.log(this.vueQusetion)
    },
    change (params) {
      //console.log(this.vueQusetion[params.index], params.index, params.row)
      this.isAnswer()
    },
    isAnswer (item) {
      if (item.name) {
        this.item.isAnswer = true
        this.$emit('change', item, this.index, true)
      } else {
        for (let q of this.item.vueQusetion) {
          for (let i in q) {
            if (q[i].name) {
              this.$emit('change', item, this.index, true)
              return
            }
          }
        }
        this.$emit('change', item, this.index, false)
      }
    }
  },
  components: {
    IconFont
  }
}
</script>
<style lang="scss">
  .table-qusetion{
    border-bottom:1px solid rgba(0,0,0,0.09);
    .content{
      min-height: 48px;
      text-align: center;
      padding: 12px 0;
    }
    input{
      width: 100%;
      height: 22px;
    }
  }
</style>
<style lang="scss" scoped>
.iv-table-operation {
  overflow: hidden ;
  padding-bottom: 5px;
}
</style>